import React from "react";
import { FormattedMessage as FM } from "react-intl";

import { getStorage } from "store/local";
import { classNames } from "tools/ui";
import proxy from "api/proxy";
import funcs from "tools/functions";
import { EnvelopeIcon, PrintIcon } from "components/Icons";

const styleIcon = "w-12 active:scale-95 fill-current";
const iconDiv =
  "flex justify-center items-center p-3 w-12 rounded-md mx-2 bg-stone-100 text-stone-500 hover:bg-white hover:text-sky-700 active:bg-sky-800 active:text-white active:scale-95";

function MenuItemReport({ item, activeRecord, active, dialogMesssage }) {
  const session = getStorage("ctxSession");
  if (active && active === false) return null;
  const storeStd = {
    company: session.company,
    id: activeRecord.id,
  };

  async function printDirectReport(report) {
    const { reportUrl, nameFile } = await proxy.report({
      report: report.name,
      data: storeStd,
      records: [activeRecord.id],
    });
    funcs.createReportLink(reportUrl, nameFile);
  }

  return (
    <div
      key={item.name}
      className="flex px-3 py-2 relative gap-x-6 rounded-lg hover:bg-stone-100 hover:text-sky-700 hover:cursor-pointer"
      onClick={item.onClick}
    >
      <div>
        <p className="mb-2">
          <FM id={item.name} />
        </p>
        <p className="text-stone-400 mt-auto">
          <FM id={item.description} />
        </p>
      </div>
      <div className="flex ml-auto justify-items-end">
        {item.send_print && (
          <button
            type="button"
            key="div-report-icon-print"
            className={iconDiv}
            onClick={() => printDirectReport(item)}
          >
            <PrintIcon key={item.name} className={styleIcon} />
          </button>
        )}
        {item.sendEmail && (
          <button
            type="button"
            key="div-report-icon-email"
            className={iconDiv}
            onClick={() => item.sendEmail(activeRecord)}
          >
            <EnvelopeIcon key={item.name} className={styleIcon} />
          </button>
        )}
        {item.print_modal && (
          <button
            type="button"
            key="div-report-icon-email"
            className={iconDiv}
            onClick={item.send_email}
          >
            <i
              key={item.name}
              className={classNames(styleIcon, "fi fi-rr-envelope")}
            />
          </button>
        )}
      </div>
    </div>
  );
}

export default MenuItemReport;
